import React from 'react'
import '../pages/css/Home.css';
import Retail1 from '../images/retail1.jpg';
import Retail2 from '../images/retail2.jpg';
import Retail3 from '../images/retail3.jpg';
import banner from '../images/retail-banner.webp';

function Retail() {
    return (
        <>   <section
            id="contact-section-page"
            style={{
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative', // Important for overlay
                zIndex: 1,
            }}
        >
            {/* Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // semi-transparent black
                    zIndex: 2,
                }}
            ></div>

            <section className="container-fluid px-3 px-md-5 pt-3 pb-5" style={{ position: 'relative', zIndex: 3 }}>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-10">
                        <h1 className="fw-bold display-5 text-white" style={{ fontSize: '4.5rem' }}>Retail Ecommerce
                        </h1>
                        <p className="fs-2 fw-medium text-white mt-3">
                            We craft seamless e-commerce platforms and retail solutions that boost engagement, streamline operations, and drive revenue across all digital touchpoints.
                        </p>
                    </div>
                </div>
            </section>
        </section>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Our  <span className="highlight-orange">Retail</span> Services
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Retail Software Solutions */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={Retail1}
                            alt="Retail Software Solutions"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Retail</span> Software Development
                        </h1>
                        <p className="mb-4">
                            <h2>Empowering retail with omnichannel commerce, POS, and customer engagement platforms.</h2>
                        </p>

                        <h6 className="fw-bold mb-2 highlight-orange">Key Highlight:</h6>
                        <p className="mb-4 ps-3">
                            <h4>We develop customized retail solutions for inventory, CRM, in-store tech, and digital storefronts to drive growth and efficiency.</h4>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* E-commerce Platform Development */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">E-commerce</span> Solutions
                        </h1>

                        <p className="mb-4">
                            <h2>Build scalable, mobile-first e-commerce platforms tailored for seamless online shopping experiences.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Multi-Vendor Marketplaces</h4>
                        <p className="mb-2 ps-3">
                            <h5>Launch feature-rich platforms like Amazon or Flipkart with vendor panels, inventory sync, and analytics.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Custom Shopping Carts</h4>
                        <p className="mb-2 ps-3">
                            <h5>Develop secure and optimized shopping cart experiences with one-click checkout and dynamic pricing.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Payment Gateway Integration</h4>
                        <p className="mb-2 ps-3">
                            <h5>Integrate Stripe, Razorpay, PayPal, or custom gateways with fraud detection and compliance handling.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Customer Engagement Tools</h4>
                        <p className="mb-2 ps-3">
                            <h5>Leverage loyalty programs, personalized promotions, and real-time support chat to increase conversions.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={Retail2}
                            alt="E-commerce Platform Development"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Omnichannel Retail & Analytics */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={Retail3}
                            alt="Retail Analytics and Omnichannel Tech"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Omnichannel</span> Retail & Analytics
                        </h1>

                        <p className="mb-4">
                            <h2>Deliver a unified shopping experience across online, mobile, and in-store with intelligent insights.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">POS Integration</h4>
                        <p className="mb-2 ps-3">
                            <h5>Sync physical store transactions with digital storefronts for real-time inventory and sales updates.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">AI-Powered Recommendations</h4>
                        <p className="mb-2 ps-3">
                            <h5>Boost average order value with personalized product suggestions using customer behavior and purchase history.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Retail Analytics Dashboard</h4>
                        <p className="mb-2 ps-3">
                            <h5>Visualize KPIs, manage promotions, and track ROI with intuitive dashboards for actionable decision-making.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            </section>

        </>

    )
}

export default Retail;